import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';

var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    VMenu,
    {
      staticClass: "menu-settings",
      attrs: {
        "offset-x": "",
        top: "",
        transition: "slide-y-transition",
        "close-on-content-click": false,
        dense: "",
      },
      scopedSlots: _vm._u([
        {
          key: "activator",
          fn: function (ref) {
            var on = ref.on
            return [
              _c(
                VBtn,
                _vm._g({ attrs: { icon: "", small: "" } }, on),
                [_c(VIcon, [_vm._v("icon-config")])],
                1
              ),
            ]
          },
        },
      ]),
    },
    [
      _c(
        VList,
        { attrs: { dense: "", nav: "" } },
        [
          _vm._l(_vm.configMenu, function (menuItem) {
            return _vm._l(menuItem.subItems, function (item) {
              return _vm.requireRole(item) && _vm.checkFlags(item)
                ? _c(
                    VListItem,
                    {
                      attrs: { dense: "" },
                      on: {
                        click: function ($event) {
                          return _vm.onOpenUrl(item)
                        },
                      },
                    },
                    [
                      _c(VListItemTitle, [
                        _vm._v(_vm._s(item.key ? _vm.$t(item.key) : item.name)),
                      ]),
                    ],
                    1
                  )
                : _vm._e()
            })
          }),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }